import { ModelType } from "@/gql/graphql";
import { ActivityLogFeed } from "@/app/ActivityLogs/Components/ActivityLogFeed";
import { BookingDuplicateWarning } from "../Components/Banners/BookingDuplicateWarning";
import { useBookingRecord } from "@/app/Bookings/Hooks/useBookingRecord";
import { BookingPaymentCard } from "@/app/Bookings/Components/Cards/BookingPaymentCard";
import { BookingTripCard } from "@/app/Bookings/Components/Cards/BookingTripCard";
import { BookingCustomerCard } from "@/app/Bookings/Components/Cards/BookingCustomerCard";
import { BookingNoPaymentWarning } from "@/app/Bookings/Components/Banners/BookingNoPaymentWarning";
import { WarningBanner } from "@/lib/Components/Banners/WarningBanner";
import { Link } from "@/components/catalyst/link";
import { BookingVehicleCard } from "@/app/Bookings/Components/Cards/BookingVehicleCard";
import { BookingInsuranceCard } from "@/app/Bookings/Components/Cards/BookingInsuranceCard";

export function BookingDetailsScreen() {
  const record = useBookingRecord();

  return (
    <div className="space-y-6 py-6">
      {record.original_relocation_id !== record.relocation.id ? (
        <WarningBanner>
          <p className="text-sm">
            The relocation has been changed since the booking was created{" "}
            <Link
              from="/$tenant/$orgId/supplier/{-$supplierId}"
              to="/$tenant/$orgId/supplier/{-$supplierId}/relocations/$relocationId"
              params={(prev) => ({
                ...prev,
                relocationId: record.original_relocation_id,
              })}
            >
              View original
            </Link>
          </p>
        </WarningBanner>
      ) : null}

      <BookingDuplicateWarning booking={record} />

      <div className="grid gap-6 xl:grid-cols-7">
        <div className="space-y-6 xl:col-span-4">
          <BookingCustomerCard />
          <BookingTripCard booking={record} />
          <BookingVehicleCard />
          <BookingInsuranceCard />
        </div>
        <div className="space-y-6 xl:col-span-3">
          <BookingPaymentCard />
          <BookingNoPaymentWarning />
          <ActivityLogFeed modelId={record.id} modelType={ModelType.Booking} />
        </div>
      </div>
    </div>
  );
}
